import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import HomePage from './components/HomePage';
import LoginPage from './components/LoginPage';
import SignupPage from './components/SignupPage';
import CreatorDashboard from './components/CreatorDashboard';
import CreateDigitalProduct from './components/CreateDigitalProduct';
import EditDigitalProduct from './components/EditDigitalProduct';
import SalesPage from './components/SalesPage';
import AccessPage from './components/AccessPage';
import AdminDashboard from './components/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import FAQPage from './components/FAQPage';
import StoreView from './components/StoreView';
import MarketplacePage from './components/MarketplacePage';
import MarketerDashboard from './components/MarketerDashboard';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import AccessUrlPage from './components/AccessUrlPage';
import RoadmapPage from './components/RoadmapPage';
import NotFoundPage from './components/NotFoundPage';
import PricingPage from './components/PricingPage';


const App: React.FC = () => {
  return (
    <>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />}/>
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/roadmap" element={<RoadmapPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/store/:username" element={<StoreView />} />
        <Route path="/marketplace" element={<MarketplacePage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <CreatorDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/marketer-dashboard"
          element={
            <ProtectedRoute>
              <MarketerDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create"
          element={
            <ProtectedRoute>
              <CreateDigitalProduct />
            </ProtectedRoute>
          }
        />
        <Route path="/sales/:slug" element={<SalesPage />} />
        <Route path="/access/:token" element={<AccessPage />} />
        <Route path="/access-url" element={<AccessUrlPage />} />
        <Route
          path="/edit/:slug"
          element={
            <ProtectedRoute>
              <EditDigitalProduct />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        {/* Catch-all. Without this, an unknown URL rendered a blank page. */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

export default App;